/* eslint-disable @typescript-eslint/no-explicit-any */
import { ConditionRenderer } from "@/components/shared/condition-renderer";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

type DocumentFormProp = {
  value: any;
  textType?: string;
  onChange: (prop: any) => void;
  onBlur: () => void;
};

export const DocumentTableForm = ({
  value,
  onChange,
  onBlur,
  textType,
}: DocumentFormProp) => {
  return (
    <ConditionRenderer condition={textType === "text"}>
      <Input
        onBlur={onBlur}
        className=""
        value={value}
        onChange={(e: any) => onChange(e?.target?.value)}
        autoFocus={true}
      />
      <Textarea
        onBlur={onBlur}
        className="min-h-[100px] bg-white"
        value={value}
        onChange={(e: any) => onChange(e?.target?.value)}
        autoFocus={true}
      />
    </ConditionRenderer>
  );
};
